module.exports = __webpack_public_path__ + "static/media/user.e1b98ef8.svg";